import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import LeadsTable from "./LeadsTable";
import AdminSideNav from "../../../adminComponents/sidenav";
import AdminHeader from "../../../adminComponents/header";

const AdminLeads = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ml: { xs: "0px", md: "200px" },
        }}
      >
        <AdminSideNav />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <AdminHeader title={"All Leads"} />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
          }}
        >
          <LeadsTable />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLeads;
